import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {string} props.name
 * @returns {JSX.Element}
 */
export const ShippingStrategyDefaultTagWithName = ({ name }) => {
  return (
    <div className={style['strategy-and-tag']}>
      <div>{name}</div>
      <div className={style['strategy-default-tag']}>
        <FormattedMessage {...messages.shipstationDefaultText} />
      </div>
    </div>
  );
};
